import React from 'react';
import { useTheme } from 'styled-components';
import Typography from '../Typography';
import { Tag, Wrapper } from './styles';

type TagsDisplayArea = {
  tags: string[];
};

const TagsDisplayArea = ({ tags }: TagsDisplayArea) => {
  const theme = useTheme();
  return (
    <Wrapper>
      {tags.map((tag, index) => (
        <Tag key={index}>
          <Typography variant="utility4" color={theme.colors.neutral[600]}>
            {tag}
          </Typography>
        </Tag>
      ))}
    </Wrapper>
  );
};

export default TagsDisplayArea;
